function initSingleMap( mapEl ) {

    const lat  = parseFloat( mapEl.dataset.lat );
    const lng  = parseFloat( mapEl.dataset.lng );
    const zoom = parseInt( mapEl.dataset.zoom, 10 );

    const position = { lat, lng };

    const map = new google.maps.Map( mapEl, {
        center: position,
        zoom: zoom,
        scrollwheel: false,
    });

    new google.maps.Marker({
        position: position,
        map: map,
    });

}

function initAllMaps() {

    const maps = document.querySelectorAll('.acf-map');

    if ( ! maps.length ) return;

    maps.forEach( mapEl => initSingleMap( mapEl ) );
}

// Exposée en global : appelée par l'API Google Maps elle-même une fois prête
// (callback=initAllMaps passé dans l'URL du script, cf enqueue.php) plutôt que
// de deviner le bon moment via DOMContentLoaded.
window.initAllMaps = initAllMaps;

